// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PrinterTwoToneSvg from "@ant-design/icons-svg/es/asn/PrinterTwoTone";
import AntdIcon from '../components/AntdIcon';

var PrinterTwoTone = function PrinterTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PrinterTwoToneSvg
  }));
};

PrinterTwoTone.displayName = 'PrinterTwoTone';
export default React.forwardRef(PrinterTwoTone);